import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { token } from "@atlaskit/tokens";

import { JiraOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    CreateASiteHeading,
    CreateASiteText,
    Headings
} from "../../../components";

export const LoggedInJiraNewUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    const subheading = (
        <FormattedMessage
            id="siteActivation.loggedInJira.newUser"
            defaultMessage="Sites are the shared space where people organize teams, work, and projects."
        />
    );
    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm">
                <div css={containerCss}>
                    {team26VisualUpdates ? (
                        <Headings main={<CreateASiteText />} sub={subheading} />
                    ) : (
                        <div css={headerGroupCss}>
                            <h1 css={headerCss}>
                                <span css={accentImageSpanCss}>
                                    <CreateASiteHeading />
                                </span>
                            </h1>
                            <p css={headerCss}>{subheading}</p>
                        </div>
                    )}
                    <SiteActivation useContactExpandCohortLogic={true} />
                </div>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const containerCss = css({
    display: "flex",
    flexDirection: "column"
});

const headerGroupCss = css({
    display: "grid",
    gap: token("space.100")
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const accentImageSpanCss = css({
    position: "relative"
});
